import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
import Button from "~/components/Button";
import Text from "~/components/Text";
import useUtmParams from "~/hooks/useUtmParams";
import Trans from "~/types/translationKeys";
import styles from "./HowItWorks.module.scss";

const HowItWorks: React.FC = () => {
  const { t } = useTranslation();
  const utmParams = useUtmParams();

  return (
    <section id="how-it-works" className={styles.section}>
      <img
        alt={"decorator"}
        src={"/images/referral_decorator.png"}
        className={styles.decorator}
      />

      <Text
        type={"headline-4"}
        className={styles.title}
        align={"center"}
        data-aos="fade-up"
      >
        {t(Trans.how_it_works)}
      </Text>

      <div className={styles.wrapper}>
        <div className={styles.flow} data-aos="fade-up">
          <hr className={styles.line} />

          <div className={styles.benefit}>
            <div className={classNames(styles.number, styles.first)}>1</div>
            <div className={styles.content_box}>
              <Text
                type="headline-4"
                align={"center"}
                color={"white"}
                className={styles.content_title}
              >
                {t(Trans.referral_step_1_title)}
              </Text>
              <Text type="body-2" className={styles.content_description}>
                {t(Trans.referral_step_1_description)}
              </Text>
            </div>
          </div>

          <div className={styles.benefit}>
            <div className={classNames(styles.number, styles.second)}>2</div>
            <div className={styles.content_box}>
              <Text
                type="headline-4"
                align={"center"}
                color={"white"}
                className={styles.content_title}
              >
                {t(Trans.referral_step_2_title)}
              </Text>
              <Text type="body-2" className={styles.content_description}>
                {t(Trans.referral_step_2_description)}
              </Text>
            </div>
          </div>

          <div className={styles.benefit}>
            <div className={classNames(styles.number, styles.third)}>3</div>
            <div className={styles.content_box}>
              <Text
                type="headline-4"
                align={"center"}
                color={"white"}
                className={styles.content_title}
              >
                {t(Trans.referral_step_3_title)}
              </Text>
              <Text type="body-2" className={styles.content_description}>
                {t(Trans.referral_step_3_description)}
              </Text>
            </div>
          </div>
        </div>

        <Link
          type="outline"
          href={{
            pathname: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in`,
            query: { ...utmParams },
          }}
          target="_blank"
        >
          <Button variant={"secondary"}>{t(Trans.start_earning_now)}</Button>
        </Link>
      </div>
    </section>
  );
};

export default HowItWorks;
